export default {"src":"/_next/static/media/cmlT3.53c96e88.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};